import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import { Button } from "@components/buttons";
import { useFixBody } from "@state/hooks/shared";

export default observer(function BetBuilderPopup() {
	const rootStore = useRootAppStore();
	useFixBody(rootStore.betBuilderPopupStore.isActive);
	const { t } = useTranslation();

	return (
		<div className="popup">
			<div className="popup__card popup__card--med">
				<div className="popup__header">
					<span>Bet Builder</span>
				</div>
				<div className="popup__body">
					<i className="u-icon u-icon--huge u-icon--alert-circle u-mar--x--auto" />
					<span>
						{rootStore.betBuilderPopupStore.betBuilderInfoText}
					</span>
				</div>
				<div className="popup__footer">
					<Button
						className="btn--base btn--primary--inverted"
						onClick={() => {
							rootStore.betBuilderPopupStore.deactivateBetBuilderPopup();
						}}
						btnText={t("COMMON.CANCEL")}
					/>

					<Button
						className="btn--base btn--accent"
						onClick={() => {
							rootStore.betBuilderPopupStore.betBuilderRoutingCallback?.();
						}}
						btnText={t("COMMON.YES")}
					/>
				</div>
			</div>
		</div>
	);
});
